// eslint-disable-next-line prettier/prettier
import type { InjectionKey } from 'vue';
import { Configuration } from '@/types/configuration.d';
import { CollapsibleAccordionContext } from './types/collapsibleAccordionContext.d';


export const configurationKey = Symbol('configurationKey') as InjectionKey<Configuration>;
export const shadowVerifiedEmailsKey =
  Symbol('shadowVerifiedEmailsKey') as InjectionKey<Record<string, string>>;
export const updateShadowVerifiedEmailsKey =
  Symbol('updateShadowVerifiedEmailsKey') as InjectionKey<(did: string, email: string) => void>;
export const collapsibleAccordionKey =
  Symbol('collapsibleAccordionKey') as InjectionKey<CollapsibleAccordionContext>;
